import {useTranslation} from 'react-i18next'
import {DatePickerV2} from '../../../../../../components/DatePickerV2/DatePickerV2'
import {TextInputV2} from '../../../../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../../../../redux/hooks'
import {filterSelector, setFilterLogAPI, setFilterLogSalesOrder} from '../../../../../../redux/slices/filterSlices'
import './RowFilter.scss'
import {TRowFilter} from '../../../../../../components/Table/Table'
import { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Selection } from 'src/components/Selection'

interface PropsData {
  error_type_list: any[]
}

export const RowFilter = (props: PropsData) => {
  const {error_type_list} = props
  const {t} = useTranslation()
  const {filterLogSalesOrder: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterLogSalesOrder({...filter, ...value}))
  } 

  useEffect(() => {
    let _filter = filter
    try{
      let storage = localStorage.getItem('redux-log-so-filter') as string

      if (storage) {
        let persisted = JSON.parse(storage)
        _filter = {
          ...filter,
          ...persisted
        }
        dispatch(setFilterLogSalesOrder(_filter))
      }

    }catch(e){
      console.log(e)
    }
  }, [])

  return (
    <TRowFilter>
      <td>
        <div style={{margin: '2px 0'}}>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('No Transaksi')}
          value={filter?.so_number ?? ''}
          onChange={({target}) => handleFilterChange({so_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Customer')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => handleFilterChange({customer_name: target.value})}
        />
      </td>
      <td>
        <Selection
          data={error_type_list.map((item: any) => {
            return {value: item?.flag, label: item?.desc}
          })}
          placeholder={t('Status')}
          value={filter?.flag ?? ''}
          onChange={(value: any) => handleFilterChange({flag: value})}
        /> 
      </td>

      <td>
        <TextInputV2
          placeholder={t('Message Error')}
          value={filter?.message ?? ''}
          onChange={({target}) => handleFilterChange({message: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('Date')}
          isSelectsRange={false}
          startDate={filter?.execution_date ?? ''}
          onChange={({startDate}) => handleFilterChange({execution_date: startDate})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('No SO')}
          value={filter?.sap_number ?? ''}
          onChange={({target}) => handleFilterChange({sap_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('No DP Req')}
          value={filter?.dp_req_sap ?? ''}
          onChange={({target}) => handleFilterChange({dp_req_sap: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('No Billing DP')}
          value={filter?.billing_number_sap ?? ''}
          onChange={({target}) => handleFilterChange({billing_number_sap: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('TableBank.bank_clearing_acct')}
          value={filter?.gl_account ?? ''}
          onChange={({target}) => handleFilterChange({gl_account: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Clearing Doc 1')}
          value={filter?.clearing_doc_1 ?? ''}
          onChange={({target}) => handleFilterChange({clearing_doc_1: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Clearing Doc 2')}
          value={filter?.clearing_doc_2 ?? ''}
          onChange={({target}) => handleFilterChange({clearing_doc_2: target.value})}
        />
      </td>
      <td>
        <Selection
          data={[
            {
              value: '1',
              label: 'IDR'
            },
            {
              value: '3',
              label: 'USD'
            }
          ]}
          placeholder={t('mataUang')}
          value={filter?.currency ?? ''}
          onChange={(value: any) => handleFilterChange({currency: value})}
        /> 
      </td>
      <td>
        <TextInputV2
          placeholder={t('Bank Payment')}
          value={filter?.bank_payment ?? ''}
          onChange={({target}) => handleFilterChange({bank_payment: target.value})}
        />
      </td>
    </TRowFilter>
  )
}
